export function jumpToSection(targetedElementId: string) {
    const targettedElement = document.getElementById(targetedElementId);
    if (!targettedElement)
        return;
    const targetElementTop = targettedElement.getBoundingClientRect().top + document.documentElement.scrollTop;

    // The two regions that share this React app (US Redesign + UCITS Redesign)
    // need slightly different scroll logic. US needs a deferred re-scroll because
    // its sticky header grows after the page enters .fixed-nav state, and the
    // first scroll has to use the post-growth measurement to land correctly.
    // UCITS works fine with a single scroll + per-device offset and we don't want
    // to regress it. Branch on the .us-fund-page marker that's only present on
    // US fund pages.
    const isUsFundPage = !!document.querySelector('.us-fund-page');

    if (isUsFundPage) {
        // offset to trigger switching the tabs when clicking on it
        const TRIGGER_OFFSET = 5

        // US path: two-pass scroll. First call kicks off the scroll (which triggers
        // the .fixed-nav state change). Second call, two frames later, re-measures
        // the now-expanded sticky header and corrects the landing position.
        const scrollToTarget = () => {
            const headerWrapper = document.querySelector(".root .sticky-wrapper");
            const headerWrapperHeight = headerWrapper?.clientHeight ?? 0;
            const stickyHeader = document.querySelector(".root .sticky-header");
            const stickyHeaderHeight = stickyHeader?.clientHeight ?? 0;
            const sidebar = document.querySelector('.sticky-left-sidebar');
            const sidebarIsFixed = sidebar?.classList.contains('fixed') ?? false;
            const sidebarHeight = sidebarIsFixed ? sidebar?.clientHeight ?? 0 : 0;

            window.scrollTo({
                behavior: "auto",
                top: targetElementTop - headerWrapperHeight - stickyHeaderHeight - sidebarHeight + TRIGGER_OFFSET,
            });
        };

        scrollToTarget();
        requestAnimationFrame(() => requestAnimationFrame(scrollToTarget));
        return;
    }

    // UCITS (and any non-US consumer) path: kept verbatim from the pre-refactor
    // version. Do NOT modify — this is the known-good code for UCITS Redesign
    // and any changes here must be re-tested against UCITS specifically.

    // Compute the bottom edge of every sticky element sitting at the top of the viewport.
    // position:fixed elements always return their viewport position from getBoundingClientRect(),
    // so the maximum .bottom across all of them is the precise end of the sticky area.
    const stickySelectors = [
        '.root .sticky-wrapper',      // main site header
        '.root .sticky-header',       // fund name / secondary nav sticky bar
        '.sticky-left-sidebar.fixed', // section nav bar when in fixed / stuck mode
    ];

    const stickyBottom = stickySelectors.reduce((max, selector) => {
        const el = document.querySelector(selector);
        if (!el) return max;
        const rect = el.getBoundingClientRect();
        // At 1850px+, .sticky-left-sidebar.fixed is a narrow left-column panel, not a full-width
        // horizontal top bar. Its padding-top (3rem) causes getBoundingClientRect().bottom to exceed
        // the actual sticky boundary. Use .top in that case — it equals the real sticky area end.
        const effectiveBottom = rect.width < window.innerWidth * 0.5 ? rect.top : rect.bottom;
        return Math.max(max, effectiveBottom);
    }, 0);

    window.scrollTo({
        behavior: "auto",
        top: targetElementTop - stickyBottom,
    });
}
